import { DATES } from 'app/_constants/dates.constant';
import { AuthService } from 'app/_services/auth.service';
import { StorageLocationResource } from 'app/_resources/storage-location.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { LoggedInUser } from '../custom';

class LngLocationOverviewCtrl implements ng.IController {
    public storageLocations: StorageLocationDto[];
    public uiLoading: boolean = true;
    public loggedInUser: LoggedInUser;
    public isLoggedIn: boolean;
    public colFiltOpts: any = {};
    public filtOpts: any = {};
    public itemsPerPage: number = 5;
    public orderBy: string = 'name';

    constructor(
        private DATES: DATES,
        private networkPointSearchService: any,
        private platformSettingsService: any,
        private authService: AuthService,
        private storageLocationResource: StorageLocationResource,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.loggedInUser = this.authService.getLoggedInUser();
        if (this.loggedInUser && this.loggedInUser.role == 'SSO_ADMIN') {
            this.colFiltOpts.favoritesOnly = true;
        }
        this.initStorageLocations();
    }

    public initStorageLocations(): void {
        this.storageLocationResource
            .getAll(
                this.colFiltOpts,
                (res: StorageLocationDto[]) => {
                    this.storageLocations = res;
                },
                this.errorHandler
            )
            .$promise.finally(() => (this.uiLoading = false));
    }
}

angular.module('app').component('pkpLngLocationOverview', {
    controller: LngLocationOverviewCtrl,
    template: require('app/lng-location/lng-location-overview.component.html')
});
